
/* eslint max-len: [1, 700, 4, { "ignoreStrings": true, "ignoreRegExpLiterals": true }] */

import React from 'react';
import PropTypes from 'prop-types';

const DefaultAvatarImage = () => (
  <svg viewBox="0 0 50 50" focusable="false">
    <path d="M25,0A25,25,0,1,0,50,25h0A25,25,0,0,0,25,0Zm0,48.7A24.33,24.33,0,0,1,7.73,41.54a8.25,8.25,0,0,1,2.6-2c1.47-.76,3-1.34,4.52-2.08a24.33,24.33,0,0,0,3.7-2.15,5.66,5.66,0,0,0,1.45-2,2.14,2.14,0,0,0-.39-2.61,9,9,0,0,1-2.12-4.52,1.74,1.74,0,0,0-.39-1c-1.66-1.44-1.51-3.4-1.47-5.31,0-.39,0-.77.08-1.16h.5a9.32,9.32,0,0,1-.07-1.13,8.86,8.86,0,1,1,17.73,0,9.32,9.32,0,0,1-.07,1.13h.5c0,.39.07.77.08,1.16,0,1.91.19,3.87-1.47,5.31a1.77,1.77,0,0,0-.39,1,9,9,0,0,1-2.12,4.52A2.14,2.14,0,0,0,30,33.2a5.71,5.71,0,0,0,1.45,2,25.65,25.65,0,0,0,3.7,2.15c1.48.74,3,1.32,4.52,2.08a8.25,8.25,0,0,1,2.59,2A24.33,24.33,0,0,1,25,48.7Z" />
  </svg>
);

const AvatarImage = props => {
  const { imgParams, messageViewType, nickname } = props;

  if (messageViewType !== 'bubble') return null;

  return (
    <div className="operator-img">
      {
        imgParams && imgParams.src
          ? (
            <img
              src={imgParams.src}
              alt={nickname}
              title={nickname}
            />
          )
          : <DefaultAvatarImage />
      }
    </div>
  );
};

if (process.env.NODE_ENV !== 'production') {
  AvatarImage.propTypes = {
    messageViewType: PropTypes.string,
    imgParams: PropTypes.object,
    nickname: PropTypes.string,
  };

  AvatarImage.defaultProps = {
    imgParams: {},
    nickname: '',
  };
}

export default AvatarImage;
